import { Instant } from "@js-joda/core";
import React from "react";
import { RaffleParticipationStatus } from "../../../messages";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import AppSlideFadeIn from "../../Generic/AppSlideFadeIn";
import { RaffleParticipant, RafflePreviousWinner, RafflePrize } from "../Raffle.types";
import RaffleCountdown from "./RaffleCountdown";
import RaffleHeading from "./RaffleHeading";
import RaffleMyTokensCard from "./RaffleMyTokensCard";
import RaffleParticipantsMarquee from "./RaffleParticipantsMarquee";
import RafflePreviousWinnersCard from "./RafflePreviousWinnersCard";
import RafflePrizeImage from "./RafflePrizeImage";
import { RaffleSection } from "./RaffleSection";
import RaffleSectionTitle from "./RaffleSectionTitle";
import { RaffleTrophy } from "./RaffleTrophy";

type Props = {
  raffleEndsAt: Instant;
  participants: RaffleParticipant[];
  previousWinners: RafflePreviousWinner[];
  prize: RafflePrize;
  tokens: number;
  shiftsPerToken: number;
  shiftsToNextToken: number;
  participationStatus: RaffleParticipationStatus;
  avatar: string | null;
};

export default function RaffleScreenUpcoming(props: Props) {
  return (
    <>
      <AppSlideFadeIn>
        <RaffleSection mt={72}>
          <RaffleHeading subTitle={translate(STRINGS.MEDFLYT_RAFFLE)} title={props.prize.name} />
        </RaffleSection>
      </AppSlideFadeIn>

      <AppSlideFadeIn delay={100}>
        <RafflePrizeImage size={200} prize={props.prize.name} prizeImage={props.prize.image} />
      </AppSlideFadeIn>

      <AppSlideFadeIn delay={200}>
        <RaffleCountdown to={props.raffleEndsAt} />
      </AppSlideFadeIn>

      <AppSlideFadeIn delay={300}>
        <RaffleSection mt={74} mx={16} mb={32}>
          <RaffleMyTokensCard
            participationStatus={props.participationStatus}
            shiftsPerToken={props.shiftsPerToken}
            tokens={props.tokens}
            shiftsToNextToken={props.shiftsToNextToken}
            avatarUrl={props.avatar}
          />
        </RaffleSection>
      </AppSlideFadeIn>

      {props.participants.length >= 6 && (
        <AppSlideFadeIn delay={400}>
          <RaffleSection mt={32}>
            <RaffleSectionTitle>{translate(STRINGS.WHOS_THE_LUCKY_ONE)}</RaffleSectionTitle>
            <RaffleParticipantsMarquee participants={props.participants} />
          </RaffleSection>
        </AppSlideFadeIn>
      )}

      {props.previousWinners.length > 0 && (
        <AppSlideFadeIn delay={500}>
          <RaffleSection mx={24} my={24}>
            <RaffleSectionTitle>
              <RaffleTrophy />
              <span>{translate(STRINGS.PREVIOUS_WINNERS)}</span>
            </RaffleSectionTitle>
            <RafflePreviousWinnersCard previousWinners={props.previousWinners} />
          </RaffleSection>
        </AppSlideFadeIn>
      )}
    </>
  );
}
